import { type FC } from 'react';

import ReactQuill from './reactQuill';

import type { Props } from './reactQuill';

const BaseRichTextEditor: FC<Props> = (props) => {
  return <ReactQuill {...props} />;
};

export default BaseRichTextEditor;
